import React from 'react';

const Order = React.memo((props) => {
    const handleSetPassword = (event) => {
        props.setPassword(event.target.value);
    };

    const handleSetConfirmPassword = (event) => {
        props.setConfirmPassword(event.target.value);
    };

    const handleSavePassword = () => {
        props.savePassword();
    };

    return (
        <div className="form-container">
            <div className="fields">
                <div className="field">
                    <div>New Password <span className="required">*</span>:</div>
                    <input type="password" name="password" value={props.password} onChange={handleSetPassword} />
                </div>
                <div className="field">
                    <div>Confirm New Password <span className="required">*</span>:</div>
                    <input type="password" name="confirmPassword" value={props.confirmPassword} onChange={handleSetConfirmPassword} />
                </div>
            </div>
            <div className="button-container">
                <button type="button" className="save-button" onClick={handleSavePassword}>
                    {props.saving ? <i className="fas fa-circle-notch fa-spin"></i> : 'Change Password'}
                </button>
            </div>
        </div>
    );
});

export default Order;
